/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Faq_Issues_QInputs */

const en_mk_tb_faq_issues_q = /** @type {(inputs: Mk_Tb_Faq_Issues_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which issue tracker works with Team Build today?`)
};

const id_mk_tb_faq_issues_q = /** @type {(inputs: Mk_Tb_Faq_Issues_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue tracker apa yang tersedia untuk Team Build sekarang?`)
};

/**
* | output |
* | --- |
* | "Which issue tracker works with Team Build today?" |
*
* @param {Mk_Tb_Faq_Issues_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_faq_issues_q = /** @type {((inputs?: Mk_Tb_Faq_Issues_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Faq_Issues_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_faq_issues_q(inputs)
	return en_mk_tb_faq_issues_q(inputs)
});